import { FC } from 'react';
import { FullBoatSearchDetail } from 'src/common/types/api/v4/boats/search';
import { RecentInquiryData } from 'src/common/utils/recentInquiryCookieData';
import TripCartSkeleton from 'src/trip-cart-deprecated/components/TripCartSkeleton';
import TripCartProvider from 'src/trip-cart-deprecated/hooks/useTripCartContext';
import TripCartOptionsProvider from 'src/trip-cart-deprecated/hooks/useTripCartOptionsContext';
import { ListingPageProps } from 'src/common/types/common/ListingPageProps';
import TripCartBookingProvider from 'src/trip-cart-deprecated/hooks/useTripCartBookingContext';
import TripCartRootContent from 'src/trip-cart-deprecated/components/TripCartRootContent';

type TripCartRootProps = {
  listing: FullBoatSearchDetail;
  tripCartCookieData?: Partial<RecentInquiryData>;
  instabookDates: string[];
  snoozeActive: boolean;
  threadId?: string;
  previewMode?: boolean;
  showAiSummary: boolean;
} & Pick<ListingPageProps, 'addonsOptional' | 'addonsLater'>;
const TripCartRoot: FC<TripCartRootProps> = ({
  listing,
  instabookDates,
  tripCartCookieData,
  snoozeActive,
  threadId,
  previewMode,
  addonsOptional = [],
  addonsLater = [],
  showAiSummary,
}) => {
  if (previewMode) {
    <TripCartSkeleton />;
  }

  return (
    <TripCartProvider
      listing={listing}
      tripCartCookieData={tripCartCookieData}
      instabookDates={instabookDates}
      snoozeActive={snoozeActive}
      threadId={threadId}
      addonsOptional={addonsOptional}
      addonsLater={addonsLater}
      showAiSummary={showAiSummary}
    >
      <TripCartBookingProvider>
        <TripCartOptionsProvider tripCartCookieData={tripCartCookieData}>
          <TripCartRootContent />
        </TripCartOptionsProvider>
      </TripCartBookingProvider>
    </TripCartProvider>
  );
};

export default TripCartRoot;
